/**
 * Overview - Multi-card overview section
 * Replaces complex OverviewBlock with simplified structure
 */

import React from 'react'
import { Container } from '@mui/material'
import TextBlock from '../blocks/TextBlock'
import CardBlock from '../blocks/CardBlock'
import ButtonBlock from '../blocks/ButtonBlock'
import ColumnLayout from '../blocks/ColumnLayout'

interface OverviewCard {
	title: string
	content: string
	image?: string
	buttons?: Array<{
		text: string
		href?: string
		style?: 'primary' | 'secondary' | 'outlined'
		openInNewTab?: boolean
	}>
}

interface OverviewProps {
	title: string
	description: string
	cards: OverviewCard[]
	columns?: 1 | 2 | 3 | 4
}

const Overview: React.FC<OverviewProps> = ({ title, description, cards, columns = 3 }) => {
	return (
		<Container component="section">
			<ColumnLayout columns={1} spacing="loose" align="center" fullWidth={true}>
				{/* Header Section */}
				<TextBlock
					title={title}
					titleLevel={2}
					titleColor="primary"
					content={description}
					align="center"
					spacing="normal"
					maxWidth="600px"
				/>

				{/* Cards Section */}
				<ColumnLayout columns={columns} spacing="normal" align="center" equalHeight={true}>
					{cards.map((card, index) => (
						<div key={index}>
							<CardBlock
								title={card.title}
								content={card.content}
								image={card.image}
								backgroundColor="white"
								hover={false}
								padding="medium"
							/>

							{card.buttons && card.buttons.length > 0 && (
								<div
									style={{
										marginTop: '16px',
										paddingLeft: '24px',
										paddingRight: '24px'
									}}
								>
									<ButtonBlock buttons={card.buttons} layout="vertical" align="left" size="medium" />
								</div>
							)}
						</div>
					))}
				</ColumnLayout>
			</ColumnLayout>
		</Container>
	)
}

export default Overview
